import Component from '../core/Component'
import $ from 'jquery'
import flickity from 'flickity-as-nav-for'

export default class Flickity extends Component
{
    constructor($element)
    {
        super($element)
        this.$doc = $(document)
        this.cellSelector = '[data-flickity-item]'
        let options = this.$element.data('options')

        let defaults = {
            // options, defaults listed

            accessibility: true,
            // enable keyboard navigation, pressing left & right keys

            adaptiveHeight: false,
            // set carousel height to the selected slide

            autoPlay: false,
            // advances to the next cell
            // if true, default is 3 seconds
            // or set time between advances in milliseconds
            // i.e. `autoPlay: 1000` will advance every 1 second

            cellAlign: 'left',
            // alignment of cells, 'center', 'left', or 'right'
            // or a decimal 0-1, 0 is beginning (left) of container, 1 is end (right)

            cellSelector: this.cellSelector,
            // specify selector for cell elements

            contain: true,
            // will contain cells to container
            // so no excess scroll at beginning or end
            // has no effect if wrapAround is enabled

            draggable: true,
            // enables dragging & flicking

            dragThreshold: 15,
            // number of pixels a user must scroll horizontally to start dragging
            // increase to allow more room for vertical scroll for touch devices
            // default: 3

            freeScroll: false,
            // enables content to be freely scrolled and flicked
            // without aligning cells

            friction: 0.3,
            // smaller number = easier to flick farther

            groupCells: true,
            // group cells together in slides

            initialIndex: 0,
            // zero-based index of the initial selected cell

            lazyLoad: false,
            // enable lazy-loading images
            // set img data-flickity-lazyload="src.jpg"
            // set to number to load images adjacent cells

            percentPosition: true,
            // sets positioning in percent values, rather than pixels
            // Enable if items have percent widths
            // Disable if items have pixel widths, like images

            prevNextButtons: false,
            // creates and enables buttons to click to previous & next cells

            pageDots: false,
            // create and enable page dots

            resize: true,
            // listens to window resize events to adjust size & positions

            rightToLeft: false,
            // enables right-to-left layout

            setGallerySize: true,
            // sets the height of gallery
            // disable if gallery already has height set with CSS

            watchCSS: false,
            // watches the content of :after of the element
            // activates if #element:after { content: 'flickity' }

            wrapAround: false
            // at end of cells, wraps-around to first for infinite scrolling
        }

        this.options = {
            ...defaults,
            ...options
        }
    }

    prepare() {
        this.flky = new flickity( this.element, this.options )

        setTimeout(() => {
            this.flky.resize()
        }, 100)
        setTimeout(() => {
            this.flky.resize()
        }, 500)

        if (this.options.customControl) {
            this.initCustomControl()
        }
    }

    initCustomControl() {
        var self = this

        var $cellButtonGroup = this.$element.parent().find('[data-flickity-dots]');
        var $cellButtons = $cellButtonGroup.find('[data-flickity-dot]');

        // select cell on dot click
        $cellButtonGroup.on( 'click', '.dot', function() {
            var index = $(this).index()
            self.flky.select( index )
        });

        this.flky.on( 'select', () => {
            $cellButtonGroup.find('.dot').removeClass('is-selected')
            $cellButtonGroup.find('.dot').eq(this.flky.selectedIndex).addClass('is-selected')
        });

        this.flky.on('resize', updateDots);

        // previous
        this.$element.parent().find('[data-flickity-prev]').on( 'click', () => {
            this.flky.previous()
        });

        // next
        this.$element.parent().find('[data-flickity-next]').on( 'click', () => {
            this.flky.next()
        });

        function updateDots () {
            $cellButtonGroup.empty()
            var count = self.flky.slides.length ;
            for (var i = 0; i<count; i++) {
                $cellButtonGroup.append('<li class="dot" data-flickity-dot></li>')
            }
        }
    }
}


// WEBPACK FOOTER //
// ./components/Flickity.js